import { useAppDispatch, useAppSelector } from "app/hooks";
import { setShowMap } from "features/krpano/details-slice";
import { useEffect } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

const SHOW_MAP = "skin_showmap();";
const HIDE_MAP = "skin_hidemap();";

type UseShowMap = (krpanoFeaturesReady: boolean) => void;

/**
 * # Show/Hide map control for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useShowMap: UseShowMap = (krpanoFeaturesReady) => {
  const showMap = useAppSelector((state) => state.krpano.showMap);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (krpanoFeaturesReady) {
      window.krpano.call(showMap ? SHOW_MAP : HIDE_MAP);
    }
  }, [krpanoFeaturesReady, showMap]);

  // This listener is for when krpano is used to open/close the map
  useEffect(() => {
    const setMapHandler = (event: WindowEventMap["krpano__show_map"]) => {
      if (
        notNullNorUndefined(event.detail) &&
        notNullNorUndefined(event.detail.showMap)
      ) {
        dispatch(setShowMap(event.detail.showMap));
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__show_map", setMapHandler);
    return () => {
      window.removeEventListener("krpano__show_map", setMapHandler);
    };
  }, [dispatch]);
};
